import { AntimalwareAntiTamperingPanelGzDataProvider } from '../dataProvider/AntimalwareAntiTamperingPanelGzDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';

export class AntimalwareAntiTamperingPanelDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, AntimalwareAntiTamperingPanelGzDataProvider);
  }
}
